import React, { useEffect } from 'react';

import LazyLoadImage, {
    LazyLoadImageProps
} from '@tb-core/components/composites/lazyload/image';
import SafeLinkWithGaEvent from '@tb-core/components/composites/safe-link-with-ga-event';
import ItemList, { ListItem } from '@tb-core/components/ui/item-list';
import Navigation from '@tb-core/components/ui/navigation';
import { updateDataLayer } from '@tb-core/helpers/analytics/google';
import { LayoutNavigationProps, LinkProps } from '@tb-core/types';

import styles from './styles.scss';

const DeliveryLogos = ({ links = [] }: LayoutNavigationProps) => {
    const listItem: ListItem = (
        { gaDataLayerConfig = {}, url, ...props }: LinkProps,
        i
    ) => {
        useEffect(() => {
            updateDataLayer({
                ...gaDataLayerConfig,
                event: 'gtm.elementVisibility'
            });
        }, []);

        return (
            <div className={styles['link-parent']} key={i}>
                <SafeLinkWithGaEvent
                    gaDataLayerConfig={gaDataLayerConfig}
                    href={url}
                >
                    <LazyLoadImage
                        {...(props.graphic as LazyLoadImageProps)}
                        className={styles['logo-background']}
                    />
                </SafeLinkWithGaEvent>
            </div>
        );
    };

    return (
        <Navigation className={styles['delivery-logos']}>
            <ItemList item={listItem} itemProps={links} />
        </Navigation>
    );
};

export default DeliveryLogos;
